/**
 * Addressbook CopilotKit Suggestions
 */

import { useCopilotChatSuggestions } from '@copilotkit/react-ui'
import { useSelector } from '@ufc/core'
import { selectAddressStats } from '../store/addressbook.selectors'

export function useAddressbookSuggestions() {
  const stats = useSelector(selectAddressStats)
  const byType = stats?.byType ?? { site: 0, office: 0, warehouse: 0, home: 0, plant: 0, customer: 0 }
  useCopilotChatSuggestions({
    instructions: `Address stats: ${stats?.total ?? 0} total addresses (${stats?.active ?? 0} active). By type: ${byType.site} sites, ${byType.office} offices, ${byType.warehouse} warehouses, ${byType.plant} plants.`,
    minSuggestions: 2,
    maxSuggestions: 3,
  })
}
